module.exports = __webpack_public_path__ + "img/pcBanner12.06cc435a.png";